import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { IoIosAdd, IoIosSave } from "react-icons/io";
import { BsCollection } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import Colors from "../../../constant/Colors";

const smalltalk = require('smalltalk')

function HeaderContainer({
  removeBackBtn,
  addBtn,
  label,
  onPressBtn,
  saveBtn,
  onBackCheck,
  onBackFunction,
  haveCollectionIcon,
  collectionIconOnClick
}) {
  const history = useHistory();

  const onBack = async () => {
    if (onBackCheck) {
      smalltalk.confirm('', 'تکایە دڵنیا بەرەوە کاتێک دەگەڕێیتەوە بەکار‌هێنەرەکە دەسڕێتەوە').then(() => {
        onBackFunction()
      })
      return
    }
    history.goBack()
  };
  return (
    <div style={{ zIndex: 40 }} className="flex justify-center mb-9">

      <div className="fixed flex items-center justify-between w-4/5 h-12 bg-mainAqwaBlue border-x">
        <div className="flex flex-row items-center h-full">
          {!removeBackBtn && (
            <button
              onClick={onBack}
              className="flex items-center justify-center h-full px-8 bg-whiteCardIndexColor"
            >
              <AiOutlineArrowLeft color={Colors.mainWhite} size={30} />
            </button>
          )}
          {!!label && (
            <div className="">
              <h1 className="p-2 ml-8 font-bold text-white">{label}</h1>
            </div>
          )}
        </div>

        <div className="flex flex-row items-center h-full">
          {haveCollectionIcon && (
            <button
              onClick={collectionIconOnClick}
              className="flex items-center justify-center h-full px-8 mx-2 bg-whiteCardIndexColor"
            >
              <BsCollection color="#fff" size={26} />
            </button>
          )}
          {addBtn && (
            <button
              onClick={onPressBtn}
              className="flex items-center justify-center h-full px-8 bg-whiteCardIndexColor"
            >
              <IoIosAdd color="#fff" size={26} />
            </button>
          )}
        </div>


        {saveBtn && (
          <button
            onClick={onPressBtn}
            className="flex items-center justify-center h-full px-8 bg-whiteCardIndexColor"
          >
            <IoIosSave color="#fff" size={26} />
          </button>
        )}
      </div>
    </div>
  );
}

export default HeaderContainer;
